module.exports = __webpack_public_path__ + "img/1288397403.8fe018d0.jpg";